// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ink-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.item-giver {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  z-index: 50;
}
.item-giver__window {
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(11, 15, 19, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  animation: ink-enter 0.16s ease-out;
  pointer-events: auto;
  position: relative;
  width: min(1100px, 92vw);
  height: min(860px, 88vh);
  min-height: 480px;
  display: flex;
  flex-direction: column;
  padding: 20px 24px 18px;
}
.item-giver__window * {
  box-sizing: border-box;
}
@media (prefers-reduced-motion: reduce) {
  .item-giver__window {
    animation: none;
  }
}
.item-giver__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  flex: none;
}
.item-giver__title-group {
  display: flex;
  align-items: center;
  gap: 10px;
}
.item-giver__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: 24px;
  line-height: 1.15;
  letter-spacing: 0.01em;
  color: #ebe8e1;
}
.item-giver__header-right {
  display: flex;
  align-items: center;
  gap: 14px;
}
.item-giver__building {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
}
.item-giver__toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
  flex: none;
}
.item-giver__search {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  flex: 1;
  width: auto;
}
.item-giver__search:focus {
  outline: none;
  border-color: var(--gold-main);
}
.item-giver__search::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.item-giver__group-toggle {
  display: flex;
  flex: none;
  gap: 2px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.item-giver__toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 12px;
  margin-bottom: -1px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #aeaba2;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  cursor: pointer;
}
.item-giver__toggle-btn:hover {
  color: #ebe8e1;
}
.item-giver__toggle-btn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}
.item-giver__toggle-btn--active {
  color: var(--gold-light);
  border-bottom-color: var(--gold-main);
}
.item-giver__body {
  display: flex;
  gap: 18px;
  flex: 1;
  min-height: 0;
}
.item-giver__sidebar {
  flex: 0 0 min(260px, 28%);
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding-right: 14px;
  border-right: 1px solid rgba(255, 255, 255, 0.12);
}
.item-giver__sidebar-categories {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-height: 0;
}
.item-giver__sidebar-categories::-webkit-scrollbar {
  width: 6px;
}
.item-giver__sidebar-categories::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.item-giver__sidebar-sets {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 0 0 auto;
  max-height: 40%;
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.item-giver__sidebar-sets::-webkit-scrollbar {
  width: 6px;
}
.item-giver__sidebar-sets::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.item-giver__sidebar-heading {
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
  flex: none;
  margin-bottom: 4px;
}
.item-giver__hint-small {
  font-size: 13px;
  line-height: 1.5;
  color: #8d8a82;
}
.item-giver__set-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  padding: 5px 8px;
  border-radius: 6px;
}
.item-giver__set-row:hover {
  background: rgba(255, 255, 255, 0.04);
}
.item-giver__set-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: #ebe8e1;
}
.item-giver__set-count {
  color: #8d8a82;
}
.item-giver__set-actions {
  display: flex;
  flex: none;
  gap: 4px;
}
.item-giver__set-actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  padding: 5px 10px;
  font-size: 13px;
  padding: 3px 9px;
}
.item-giver__set-actions button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.item-giver__set-actions button:active:not(:disabled) {
  transform: translateY(1px);
}
.item-giver__set-actions button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.item-giver__set-actions button:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.item-giver__category {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  text-align: left;
  color: #aeaba2;
  background: transparent;
  border: 0;
  border-left: 2px solid transparent;
  border-radius: 0 6px 6px 0;
  cursor: pointer;
  transition: color 0.12s ease, background-color 0.12s ease;
}
.item-giver__category:hover {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.04);
}
.item-giver__category:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: -2px;
}
.item-giver__category--active {
  color: var(--gold-light);
  background: rgba(255, 255, 255, 0.07);
  border-left-color: var(--gold-main);
}
.item-giver__category--child {
  padding-left: 22px;
  font-size: 13px;
}
.item-giver__category-caret {
  flex: none;
  width: 12px;
  color: #8d8a82;
  font-size: 12px;
}
.item-giver__category-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-giver__category-count {
  flex: none;
  font-size: 13px;
  color: #8d8a82;
}
.item-giver__main {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.item-giver__main::-webkit-scrollbar {
  width: 6px;
}
.item-giver__main::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
.item-giver__hint {
  font-size: 14px;
  line-height: 1.5;
  color: #aeaba2;
  margin: auto;
  max-width: 60ch;
}
.item-giver__truncated {
  flex: none;
  margin-bottom: 10px;
  font-size: 13px;
  color: var(--gold-light);
}
.item-giver__category-actions {
  flex: none;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
.item-giver__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  gap: 8px;
  align-content: start;
}
.item-giver__set-header {
  font-size: 13px;
  font-weight: 600;
  color: #aeaba2;
  grid-column: 1/-1;
  padding: 4px 2px 0;
}
.item-giver__set-header:not(:first-child) {
  margin-top: 6px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.item-giver__item {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 10px 34px 10px 12px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.12s ease, background-color 0.12s ease;
}
.item-giver__item:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: var(--gold-dark);
}
.item-giver__item:active {
  transform: translateY(1px);
}
.item-giver__item:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.item-giver__item-check {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 16px;
  height: 16px;
  accent-color: var(--gold-main);
  cursor: pointer;
}
.item-giver__item-name {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.25;
  color: #ebe8e1;
}
.item-giver__item-id {
  font-family: monospace;
  font-size: 13px;
  color: #8d8a82;
}
.item-giver__item-dup {
  font-size: 13px;
  font-weight: 600;
  color: var(--gold-light);
}
.item-giver__item-qty {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  width: 56px;
  padding: 3px 6px;
  font-size: 13px;
  text-align: center;
}
.item-giver__item-qty:focus {
  outline: none;
  border-color: var(--gold-main);
}
.item-giver__item-qty::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.item-giver__basket {
  flex: none;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}
.item-giver__basket-count {
  flex: none;
  font-size: 14px;
  font-weight: 600;
  color: var(--gold-light);
  white-space: nowrap;
}
.item-giver__basket-name {
  width: 100%;
  padding: 9px 11px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ebe8e1;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  user-select: text;
  flex: 1;
  width: auto;
  min-width: 0;
}
.item-giver__basket-name:focus {
  outline: none;
  border-color: var(--gold-main);
}
.item-giver__basket-name::placeholder {
  color: #8d8a82;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  text-transform: none;
  letter-spacing: normal;
  opacity: 1;
}
.item-giver__item-3d {
  flex: none;
  padding: 1px 7px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 3px;
  font-size: 12px;
  color: var(--gold-light);
  cursor: pointer;
}
.item-giver__item-3d:hover {
  border-color: var(--gold-light);
}
.item-giver__preview {
  position: absolute;
  right: 24px;
  bottom: 76px;
  z-index: 5;
  width: 288px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  background: rgba(20, 24, 30, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
}
.item-giver__preview-title {
  font-size: 14px;
  color: var(--gold-light);
  text-align: center;
}
.item-giver__preview-image {
  width: 256px;
  height: 256px;
  image-rendering: auto;
}
.item-giver__preview-note {
  padding: 24px 8px;
  font-size: 13px;
  color: #8d8a82;
  text-align: center;
}
.item-giver__feedback {
  flex: none;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  font-size: 14px;
  color: var(--gold-light);
}
.item-giver__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}
.item-giver__button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  border-color: var(--gold-dark);
}
.item-giver__button:active:not(:disabled) {
  transform: translateY(1px);
}
.item-giver__button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.item-giver__button:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.item-giver__button--primary {
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.item-giver__button--primary:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}
.item-giver__button--secondary { /* neutral, same as the base button */ }
.item-giver__button--quiet {
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
}
.item-giver__button--quiet:hover:not(:disabled) {
  color: #ebe8e1;
  background: rgba(255, 255, 255, 0.07);
  border-color: transparent;
}

@media (max-width: 900px) {
  .item-giver__window {
    width: 96vw;
    height: 92vh;
  }
  .item-giver__body {
    flex-direction: column;
  }
  .item-giver__sidebar {
    flex: 0 0 auto;
    max-height: 220px;
    padding-right: 0;
    padding-bottom: 8px;
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  }
  .item-giver__sidebar-categories {
    flex-direction: row;
    flex-wrap: wrap;
    overflow-y: auto;
  }
  .item-giver__category {
    flex: 0 0 auto;
  }
  .item-giver__basket {
    flex-wrap: wrap;
  }
  .item-giver__basket-name {
    flex: 1 0 100%;
    order: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/_ink.scss","webpack://./src/components/ItemGiver/styles.scss"],"names":[],"mappings":"AAmLA;EACE;IAAO,UAAA;IAAY,0BAAA;EChLnB;EDiLA;IAAO,UAAA;IAAY,eAAA;EC7KnB;AACF;AAJA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,yDDeU;ECdV,WAAA;AAMF;AADE;EDYA,yDAHU;EAIV,cAbK;EAoBL,kCAzBI;EA0BJ,0CAAA;EACA,kBAjBO;EAkBP,0CAAA;EACA,0BAAA;EAiIA,mCAAA;ECtJE,oBAAA;EACA,kBAAA;EACA,wBAAA;EACA,wBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AASJ;ADLE;EAAI,sBAAA;ACQN;ADqIE;EC3JA;ID2J0C,eAAA;ECjI1C;AACF;AAdE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;AAgBJ;AAbE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAeJ;AAZE;EDOA,kDA3BW;EA4BX,gBAAA;EACA,eCRqB;EDSrB,iBAAA;EACA,sBAAA;EACA,cAxCK;ACgDP;AAhBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAkBJ;AAfE;EDYA,eAAA;EACA,gBAAA;EACA,cAlDO;ACwDT;AAhBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;AAkBJ;AAfE;EDkEA,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ECxEE,OAAA;EACA,WAAA;AAyBJ;ADgDE;EAAU,aAAA;EAAe,8BAAA;AC5C3B;AD6CE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACtC1G;AAjCE;EACE,aAAA;EACA,UAAA;EACA,QAAA;EACA,kDAAA;AAmCJ;AAhCE;EDsGA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,yDAjKU;EAkKV,eAAA;EACA,gBAAA;EACA,cA5KO;EA6KP,uBAAA;EACA,SAAA;EACA,oCAAA;EACA,eAAA;ACnEF;ADqEE;EAAU,cAnLL;ACiHP;ADmEE;EAAkB,oCAAA;EAAsC,oBAAA;AC/D1D;AAnDI;EDsHF,wBAAA;EACA,qCAAA;AChEF;AApDE;EACE,aAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;AAsDJ;AAnDE;EACE,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,iDAAA;AAqDJ;AAlDE;ED2DA,gBAAA;EACA,qBAAA;EACA,qDAAA;EC3DE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,OAAA;EACA,aAAA;AAsDJ;ADGE;EAAuB,UAAA;ACAzB;ADCE;EAA6B,oCAAA;EAAsC,kBAAA;ACGrE;AA1DE;EDkDA,gBAAA;EACA,qBAAA;EACA,qDAAA;EClDE,cAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,+CAAA;AA8DJ;ADjBE;EAAuB,UAAA;ACoBzB;ADnBE;EAA6B,oCAAA;EAAsC,kBAAA;ACuBrE;AAlEE;EDlDA,eAAA;EACA,gBAAA;EACA,cAzDO;EC2GL,UAAA;EACA,kBAAA;AAsEJ;AAnEE;ED9DA,eAAA;EACA,gBAAA;EACA,cAlDO;ACsLT;AApEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,gBAAA;EACA,kBDrHK;AC2LT;AApEI;EAAU,qCDhID;ACuMb;AApEE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,cDpIG;AC0MP;AAnEE;EACE,cDtIK;AC2MT;AAlEE;EACE,aAAA;EACA,UAAA;EACA,QAAA;AAoEJ;AAlEI;EDjFF,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;EAiCA,iBAAA;EACA,eAAA;ECmCI,gBAAA;AAoFN;ADvJE;EAAyB,qCAAA;EAAuC,8BAAA;AC2JlE;AD1JE;EAA0B,0BAAA;AC6J5B;AD5JE;EAAa,YAAA;EAAc,mBAAA;ACgK7B;AD/JE;EAAkB,oCAAA;EAAsC,mBAAA;ACmK1D;AA/FE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,iBAAA;EACA,yDDpJQ;ECqJR,eAAA;EACA,gBAAA;EACA,cD/JK;ECgKL,uBAAA;EACA,SAAA;EACA,kCAAA;EACA,0BAAA;EACA,eAAA;EACA,yDAAA;AAiGJ;AA/FI;EAAU,cDxKP;ECwKyB,qCD5KnB;AC+Qb;AAlGI;EAAkB,oCAAA;EAAsC,oBAAA;AAsG5D;AApGI;EACE,wBAAA;EACA,qCAAA;EACA,mCAAA;AAsGN;AAnGI;EACE,kBAAA;EACA,eAAA;AAqGN;AAjGE;EACE,UAAA;EACA,WAAA;EACA,cDxLK;ECyLL,eAAA;AAmGJ;AAhGE;EACE,OAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAkGJ;AA/FE;EACE,UAAA;EACA,eAAA;EACA,cDvMK;ACwST;AA9FE;ED5DA,gBAAA;EACA,qBAAA;EACA,qDAAA;EC4DE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAkGJ;AD/JE;EAAuB,UAAA;ACkKzB;ADjKE;EAA6B,oCAAA;EAAsC,kBAAA;ACqKrE;AAtGE;EDxKA,eAAA;EACA,gBAAA;EACA,cA7CO;ECqNL,YAAA;EACA,eAAA;AA0GJ;AAvGE;EACE,UAAA;EACA,mBAAA;EACA,eAAA;EACA,wBAAA;AAyGJ;AAtGE;EACE,UAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AAwGJ;AArGE;EACE,aAAA;EACA,4DAAA;EACA,QAAA;EACA,oBAAA;AAuGJ;AApGE;EDvLA,eAAA;EACA,gBAAA;EACA,cAzDO;ECgPL,iBAAA;EACA,kBAAA;AAwGJ;AAtGI;EACE,eAAA;EACA,iBAAA;EACA,+CAAA;AAwGN;AApGE;ED9NA,qCAjCW;EAkCX,2CAAA;EACA,kBA1BO;ECwPL,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,4BAAA;EACA,yDD1PQ;EC2PR,cDpQG;ECqQH,eAAA;EACA,gBAAA;EACA,gEAAA;AAwGJ;AAtGI;EAAU,qCAAA;EAAuC,8BAAA;AA0GrD;AAzGI;EAAW,0BAAA;AA4Gf;AA3GI;EAAkB,oCAAA;EAAsC,mBAAA;AA+G5D;AA5GE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,eAAA;AA8GJ;AA3GE;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cDhSG;AC6YP;AA1GE;EACE,sBAAA;EACA,eAAA;EACA,cDpSK;ACgZT;AAzGE;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;AA2GJ;AAxGE;ED3LA,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;ECqLE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAkHJ;ADxSE;EAAU,aAAA;EAAe,8BAAA;AC4S3B;AD3SE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;ACkT1G;AA1HE;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,+CAAA;AA4HJ;AAzHE;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;AA2HJ;AAxHE;EDrNA,WAAA;EACA,iBAAA;EACA,yDA7GU;EA8GV,eAAA;EACA,cAxHK;EAyHL,+BA5HU;EA6HV,0CAAA;EACA,kBAtHO;EAuHP,iBAAA;EC+ME,OAAA;EACA,WAAA;EACA,YAAA;AAkIJ;ADjVE;EAAU,aAAA;EAAe,8BAAA;ACqV3B;ADpVE;EAAiB,cA7HV;EA6H0B,yDAtHvB;EAsHgD,oBAAA;EAAsB,sBAAA;EAAwB,UAAA;AC2V1G;AA1IE;EACE,UAAA;EACA,gBAAA;EACA,2CAAA;EACA,kBAAA;EACA,eAAA;EACA,wBAAA;EACA,eAAA;AA4IJ;AA1II;EACE,+BAAA;AA4IN;AAxIE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;EACA,kCAAA;EACA,2CAAA;EACA,kBAAA;AA0IJ;AAvIE;EACE,eAAA;EACA,wBAAA;EACA,kBAAA;AAyIJ;AAtIE;EACE,YAAA;EACA,aAAA;EACA,qBAAA;AAwIJ;AArIE;EACE,iBAAA;EACA,eAAA;EACA,cD3XK;EC4XL,kBAAA;AAuIJ;AApIE;EACE,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,+CAAA;EACA,eAAA;EACA,wBAAA;AAsIJ;AAnIE;ED3UA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,yDA3DU;EA4DV,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAzEK;EA0EL,qCAAA;EACA,0CAAA;EACA,kBAvEO;EAwEP,eAAA;EACA,kFAAA;ACidF;AD/cE;EAAyB,qCAAA;EAAuC,8BAAA;ACmdlE;ADldE;EAA0B,0BAAA;ACqd5B;ADpdE;EAAa,YAAA;EAAc,mBAAA;ACwd7B;ADvdE;EAAkB,oCAAA;EAAsC,mBAAA;AC2d1D;AAjKI;EDtTF,cAjFU;EAkFV,4BAAA;EACA,8BAAA;AC0dF;ADxdE;EAAyB,6BAAA;EAA+B,+BAAA;AC4d1D;AAzKI,iCAAA,qCAAA,EAAA;AACA;EDxSF,cArGO;EAsGP,uBAAA;EACA,yBAAA;ACodF;ADldE;EAAyB,cA3GpB;EA2GkC,qCAAA;EAAuC,yBAAA;ACudhF;;AA7KA;EACE;IACE,WAAA;IACA,YAAA;EAgLF;EA7KA;IACE,sBAAA;EA+KF;EA5KA;IACE,cAAA;IACA,iBAAA;IACA,gBAAA;IACA,mBAAA;IACA,kBAAA;IACA,kDAAA;EA8KF;EA3KA;IACE,mBAAA;IACA,eAAA;IACA,gBAAA;EA6KF;EA1KA;IACE,cAAA;EA4KF;EAzKA;IACE,eAAA;EA2KF;EAxKA;IACE,cAAA;IACA,QAAA;EA0KF;AACF","sourcesContent":["// Shared look of the redesigned interfaces (escape menu, ALT menu, housing\n// drawer, and every other panel brought in line with them).\n//\n// Usage from any component stylesheet:\n//   @use '../../theme/ink' as ink;      // adjust the relative path\n//   .my-panel { @include ink.panel; }\n//\n// Rules the whole UI follows:\n//   - ink background, 1px light border, ONE corner radius (6px)\n//   - accent colour only through the palette tokens --gold-main/-light/-dark\n//     (never a hard-coded gold hex), so the palette picker keeps working\n//   - Marcellus for titles, Din-pro for everything else\n//   - no ornaments, no emoji, no centred decorative rules\n//   - hover and focus states on every control, reduced-motion respected\n//   - no color-mix() / relative colour syntax (older CEF in game)\n\n$ink: rgba(11, 15, 19, 0.96);\n$ink-raised: rgba(255, 255, 255, 0.04);\n$ink-field: rgba(0, 0, 0, 0.35);\n$line: rgba(255, 255, 255, 0.12);\n$line-strong: rgba(255, 255, 255, 0.2);\n$text: #ebe8e1;\n$text-2: #aeaba2;\n$text-3: #8d8a82;\n$danger: #d9786d;\n$success: #8fbf8a;\n$radius: 6px;\n$on-accent: #14100a;\n\n$font-title: 'Marcellus', 'Cinzel', Georgia, serif;\n$font-text: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n\n@mixin base {\n  font-family: $font-text;\n  color: $text;\n  * { box-sizing: border-box; }\n}\n\n// Floating panel (modals, centred prompts, docked windows).\n@mixin panel {\n  @include base;\n  background: $ink;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n}\n\n// Raised block inside a panel.\n@mixin block {\n  background: $ink-raised;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n@mixin title($size: 22px) {\n  font-family: $font-title;\n  font-weight: 400;\n  font-size: $size;\n  line-height: 1.15;\n  letter-spacing: 0.01em;\n  color: $text;\n}\n\n@mixin lead {\n  font-size: 14px;\n  line-height: 1.5;\n  color: $text-2;\n}\n\n@mixin hint {\n  font-size: 13px;\n  line-height: 1.5;\n  color: $text-3;\n}\n\n@mixin label {\n  font-size: 13px;\n  font-weight: 600;\n  color: $text-2;\n}\n\n// Buttons: neutral by default; add the modifiers below for the other kinds.\n@mixin button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  color: $text;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n\n  &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.12); border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n}\n\n@mixin button-primary {\n  color: $on-accent;\n  background: var(--gold-main);\n  border-color: var(--gold-main);\n\n  &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n}\n\n@mixin button-danger {\n  color: $danger;\n  background: transparent;\n  border-color: rgba(217, 120, 109, 0.45);\n\n  &:hover:not(:disabled) { background: rgba(217, 120, 109, 0.14); border-color: $danger; }\n}\n\n@mixin button-quiet {\n  color: $text-3;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover:not(:disabled) { color: $text; background: rgba(255, 255, 255, 0.07); border-color: transparent; }\n}\n\n@mixin button-sm {\n  padding: 5px 10px;\n  font-size: 13px;\n}\n\n@mixin field {\n  width: 100%;\n  padding: 9px 11px;\n  font-family: $font-text;\n  font-size: 14px;\n  color: $text;\n  background: $ink-field;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  user-select: text;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; font-family: $font-text; text-transform: none; letter-spacing: normal; opacity: 1; }\n}\n\n// Pill-shaped counters are the only rounded exception (small badges).\n@mixin badge {\n  display: inline-block;\n  min-width: 20px;\n  padding: 1px 7px;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: $text-2;\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 10px;\n}\n\n@mixin scroll {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n  &::-webkit-scrollbar { width: 6px; }\n  &::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2); border-radius: 3px; }\n}\n\n@mixin enter($from: translateY(8px)) {\n  animation: ink-enter 0.16s ease-out;\n\n  @media (prefers-reduced-motion: reduce) { animation: none; }\n}\n\n@keyframes ink-enter {\n  from { opacity: 0; transform: translateY(8px); }\n  to   { opacity: 1; transform: none; }\n}\n\n// Tabs (underline style, as in the housing drawer).\n@mixin tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 12px;\n  margin-bottom: -1px;\n  font-family: $font-text;\n  font-size: 14px;\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n\n  &:hover { color: $text; }\n  &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n}\n\n@mixin tab-active {\n  color: var(--gold-light);\n  border-bottom-color: var(--gold-main);\n}\n","@use '../../theme/ink' as ink;\n\n// Item giver: tall centred ink window with a category sidebar and an item\n// grid. One primary action (give selection), neutral secondary buttons.\n\n.item-giver {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n  font-family: ink.$font-text;\n  z-index: 50;\n\n  // A tall panel reads more items per screen than a wide one and stays\n  // legible down to 720p (min-height keeps the sidebar/grid from getting\n  // crushed on a short viewport; each pane scrolls on its own).\n  &__window {\n    @include ink.panel;\n    @include ink.enter;\n    pointer-events: auto;\n    position: relative;\n    width: min(1100px, 92vw);\n    height: min(860px, 88vh);\n    min-height: 480px;\n    display: flex;\n    flex-direction: column;\n    padding: 20px 24px 18px;\n  }\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 14px;\n    flex: none;\n  }\n\n  &__title-group {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  &__title {\n    @include ink.title(24px);\n  }\n\n  &__header-right {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n  }\n\n  &__building {\n    @include ink.hint;\n  }\n\n  &__toolbar {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 14px;\n    flex: none;\n  }\n\n  &__search {\n    @include ink.field;\n    flex: 1;\n    width: auto;\n  }\n\n  &__group-toggle {\n    display: flex;\n    flex: none;\n    gap: 2px;\n    border-bottom: 1px solid ink.$line;\n  }\n\n  &__toggle-btn {\n    @include ink.tab;\n\n    &--active { @include ink.tab-active; }\n  }\n\n  &__body {\n    display: flex;\n    gap: 18px;\n    flex: 1;\n    min-height: 0;\n  }\n\n  &__sidebar {\n    flex: 0 0 min(260px, 28%);\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    padding-right: 14px;\n    border-right: 1px solid ink.$line;\n  }\n\n  &__sidebar-categories {\n    @include ink.scroll;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    flex: 1;\n    min-height: 0;\n  }\n\n  &__sidebar-sets {\n    @include ink.scroll;\n    flex: 0 0 auto;\n    max-height: 40%;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    margin-top: 12px;\n    padding-top: 12px;\n    border-top: 1px solid ink.$line;\n  }\n\n  &__sidebar-heading {\n    @include ink.label;\n    flex: none;\n    margin-bottom: 4px;\n  }\n\n  &__hint-small {\n    @include ink.hint;\n  }\n\n  &__set-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 6px;\n    padding: 5px 8px;\n    border-radius: ink.$radius;\n\n    &:hover { background: ink.$ink-raised; }\n  }\n\n  &__set-name {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 14px;\n    color: ink.$text;\n  }\n\n  &__set-count {\n    color: ink.$text-3;\n  }\n\n  &__set-actions {\n    display: flex;\n    flex: none;\n    gap: 4px;\n\n    button {\n      @include ink.button;\n      @include ink.button-sm;\n      padding: 3px 9px;\n    }\n  }\n\n  &__category {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    padding: 8px 10px;\n    font-family: ink.$font-text;\n    font-size: 14px;\n    text-align: left;\n    color: ink.$text-2;\n    background: transparent;\n    border: 0;\n    border-left: 2px solid transparent;\n    border-radius: 0 ink.$radius ink.$radius 0;\n    cursor: pointer;\n    transition: color 0.12s ease, background-color 0.12s ease;\n\n    &:hover { color: ink.$text; background: ink.$ink-raised; }\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: -2px; }\n\n    &--active {\n      color: var(--gold-light);\n      background: rgba(255, 255, 255, 0.07);\n      border-left-color: var(--gold-main);\n    }\n\n    &--child {\n      padding-left: 22px;\n      font-size: 13px;\n    }\n  }\n\n  &__category-caret {\n    flex: none;\n    width: 12px;\n    color: ink.$text-3;\n    font-size: 12px;\n  }\n\n  &__category-name {\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__category-count {\n    flex: none;\n    font-size: 13px;\n    color: ink.$text-3;\n  }\n\n  &__main {\n    @include ink.scroll;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n  }\n\n  &__hint {\n    @include ink.lead;\n    margin: auto;\n    max-width: 60ch;\n  }\n\n  &__truncated {\n    flex: none;\n    margin-bottom: 10px;\n    font-size: 13px;\n    color: var(--gold-light);\n  }\n\n  &__category-actions {\n    flex: none;\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 10px;\n  }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));\n    gap: 8px;\n    align-content: start;\n  }\n\n  &__set-header {\n    @include ink.label;\n    grid-column: 1 / -1;\n    padding: 4px 2px 0;\n\n    &:not(:first-child) {\n      margin-top: 6px;\n      padding-top: 12px;\n      border-top: 1px solid ink.$line;\n    }\n  }\n\n  &__item {\n    @include ink.block;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n    padding: 10px 34px 10px 12px;\n    font-family: ink.$font-text;\n    color: ink.$text;\n    cursor: pointer;\n    text-align: left;\n    transition: border-color 0.12s ease, background-color 0.12s ease;\n\n    &:hover { background: rgba(255, 255, 255, 0.08); border-color: var(--gold-dark); }\n    &:active { transform: translateY(1px); }\n    &:focus-visible { outline: 2px solid var(--gold-light); outline-offset: 2px; }\n  }\n\n  &__item-check {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    width: 16px;\n    height: 16px;\n    accent-color: var(--gold-main);\n    cursor: pointer;\n  }\n\n  &__item-name {\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 1.25;\n    color: ink.$text;\n  }\n\n  &__item-id {\n    font-family: monospace;\n    font-size: 13px;\n    color: ink.$text-3;\n  }\n\n  &__item-dup {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--gold-light);\n  }\n\n  &__item-qty {\n    @include ink.field;\n    width: 56px;\n    padding: 3px 6px;\n    font-size: 13px;\n    text-align: center;\n  }\n\n  &__basket {\n    flex: none;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-top: 12px;\n    padding-top: 12px;\n    border-top: 1px solid ink.$line;\n  }\n\n  &__basket-count {\n    flex: none;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--gold-light);\n    white-space: nowrap;\n  }\n\n  &__basket-name {\n    @include ink.field;\n    flex: 1;\n    width: auto;\n    min-width: 0;\n  }\n\n  &__item-3d {\n    flex: none;\n    padding: 1px 7px;\n    border: 1px solid ink.$line;\n    border-radius: 3px;\n    font-size: 12px;\n    color: var(--gold-light);\n    cursor: pointer;\n\n    &:hover {\n      border-color: var(--gold-light);\n    }\n  }\n\n  &__preview {\n    position: absolute;\n    right: 24px;\n    bottom: 76px;\n    z-index: 5;\n    width: 288px;\n    padding: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    align-items: center;\n    background: rgba(20, 24, 30, 0.96);\n    border: 1px solid ink.$line;\n    border-radius: 4px;\n  }\n\n  &__preview-title {\n    font-size: 14px;\n    color: var(--gold-light);\n    text-align: center;\n  }\n\n  &__preview-image {\n    width: 256px;\n    height: 256px;\n    image-rendering: auto;\n  }\n\n  &__preview-note {\n    padding: 24px 8px;\n    font-size: 13px;\n    color: ink.$text-3;\n    text-align: center;\n  }\n\n  &__feedback {\n    flex: none;\n    margin-top: 10px;\n    padding-top: 10px;\n    border-top: 1px solid ink.$line;\n    font-size: 14px;\n    color: var(--gold-light);\n  }\n\n  &__button {\n    @include ink.button;\n\n    &--primary { @include ink.button-primary; }\n    &--secondary { /* neutral, same as the base button */ }\n    &--quiet { @include ink.button-quiet; }\n  }\n}\n\n// Below ~900px wide, stack the sidebar above the grid instead of side-by-side\n// so category names stay readable rather than being squeezed to a sliver.\n@media (max-width: 900px) {\n  .item-giver__window {\n    width: 96vw;\n    height: 92vh;\n  }\n\n  .item-giver__body {\n    flex-direction: column;\n  }\n\n  .item-giver__sidebar {\n    flex: 0 0 auto;\n    max-height: 220px;\n    padding-right: 0;\n    padding-bottom: 8px;\n    border-right: none;\n    border-bottom: 1px solid ink.$line;\n  }\n\n  .item-giver__sidebar-categories {\n    flex-direction: row;\n    flex-wrap: wrap;\n    overflow-y: auto;\n  }\n\n  .item-giver__category {\n    flex: 0 0 auto;\n  }\n\n  .item-giver__basket {\n    flex-wrap: wrap;\n  }\n\n  .item-giver__basket-name {\n    flex: 1 0 100%;\n    order: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
